import React, { useEffect, useState } from "react";
import Button from "@material-ui/core/Button";
import PlanningMissionService from "../../../services/PlanningMissionService";
import ConfirmationDialog from "../../tools/ConfirmationDialog";
import Message from "../../tools/Message";
import { CreateTwoTone, DeleteOutlineRounded } from "@material-ui/icons";
import { Subject, CalendarToday, PostAdd, CalendarTodayTwoTone } from "@material-ui/icons";
import MissionService from "../../../services/MissionService";
import Spacer from "../../../components/Spacer";
import LoadingSimpleBackdrop from "../../tools/LoadingSimpleBackdrop";
import { useNavigate } from 'react-router-dom';
import Autocomplete from "@material-ui/lab/Autocomplete";
import Grid from "@material-ui/core/Grid";
import Typography from '@mui/material/Typography';
import TextField from "@material-ui/core/TextField";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TDRService from "../../../services/TDRService";
import CheckIcon from "@material-ui/icons/Send";
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TablePagination } from '@mui/material';
import { DownloadOutlined } from "@mui/icons-material";
import ClearIcon from '@mui/icons-material/Clear';
import { LoadingButton } from '@mui/lab';
import Slide from '@mui/material/Slide';
import { Alert, AlertTitle } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import BlockIcon from '@mui/icons-material/Block';
import Stack from "@mui/material/Stack";
import SettingsBackupRestoreIcon from '@mui/icons-material/SettingsBackupRestore';
import TimeSheetMissionService from "../../../services/TimeSheetMissionService";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function PlanningMissionTable() {
  const navigate = useNavigate();
  const [opens, setOpens] = React.useState(false);

  const [openobservation, setOpenobservation] = useState(false);
  const handleClose = () => {
    setOpens(false);
  };
  const [openalert, setOpenalert] = useState(false);
  const [statutErrorDialog, setStatutErrorDialog] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [rows, setRows] = useState([]);
  const [details, setDetails] = useState([]);
  const [note, setNote] = useState([]);
  const [idplanif, setIdplanif] = useState(0);
  const [id_to_delete, setId_to_delete] = useState(0);
  const [annule, setAnnule] = useState(false);
  const [raison, setRaison] = useState('');
  const [selectedOption, setSelectedOption] = useState('');
  const [tdrchois, setTdrchois] = useState(false);
  const [tdrexistant, setTdrexistant] = useState([]);
  const [selectid, setSelectid] = useState('');
  const [tdrid, setTdrid] = useState('');
  const [optionagenda, setOptionagenda] = useState('');
  const [agendachois, setAgendachois] = useState(false);
  const [agendaexistant, setAgendaexistant] = useState([]);
  const [agendaid, setAgendaid] = useState('');
  const [idvalidate, setIdvalidate] = useState(0);

  const statut = [
    { label: 'Tous', id: 'Tous' },
    { label: 'Nouveau', id: 'Nouveau' },
    { label: 'Planning', id: 'Planning' },
    { label: 'Réel', id: 'Réel' }
  ];

  const statutmission = [
    { label: 'Tous', id: 'Tous' },
    { label: 'En attente de validation', id: 'En attente de validation' },
    { label: 'Validé', id: 'Validé' },
    { label: 'Refusé', id: 'Refusé' }
  ];

  const [statutVal, setStatutVal] = useState(statut[1]);
  const [statutMissionVal, setStatutMissionVal] = useState(statutmission[0]);
  const [dateDebut, setDateDebut] = useState('');
  const [dateFin, setDateFin] = useState('');
  const [loading, setLoading] = useState(false);

  const options = [
    { label: 'Créer une nouvelle TDR', value: 'nouvelle' },
    { label: 'Choisir un TDR existant', value: 'existant' }
  ];

  const agendaoptions = [
    { label: 'Créer une nouvelle Agenda', value: 'nouvelle' },
    { label: 'Choisir un Agenda existant', value: 'existant' }
  ];
  const [confirmationDialog, setConfirmationDialog] = React.useState({
    openDialog: false,
    messageDialog: 'Voulez vous vraiment supprimer?',
  });
  const [iscontinue, setIscontinue] = useState(false);
  const { openDialog, messageDialog } = confirmationDialog;
  const [raisonplanning, setRaisonplanning] = useState("");
  const [message, setMessage] = React.useState({
    open: false,
    color: 'green',
    messageInfo: '',
  });
  const { open, color, messageInfo } = message;

  function handleChangetdr(event, value) {
    setTdrid(value.tdr_mission_id);
  }

  function handleChangeagenda(event, value) {
    setAgendaid(value.id);
  }

  const handleFiltrer = () => {
    // Un statut est obligatoire pour lancer la recherche.
    if (!statutVal) {
      setStatutErrorDialog(true);
      return;
    }
    setLoading(true);
    setOpenLoadingSimpleBackdrop(true);
    PlanningMissionService.getPlanning(statutVal, statutMissionVal, dateDebut, dateFin).then((result) => {
      // Le statut "appliqué" (statut_val) ne change qu'ici, une fois la recherche lancée -
      // c'est lui qui pilote l'affichage des colonnes/actions du tableau.
      setStatut_val(statutVal || { label: '' });
      if (result && result.data) {
        setRows(result.data?.map((row) => ({ ...row, id: row.mission_planning_id })));
        setOpenLoadingSimpleBackdrop(false);
        setLoading(false);
      } else {
        setOpenLoadingSimpleBackdrop(false);
        setLoading(false);
      }
    });
  };

  const handleSectionChange = (index, field, newValue) => {
    setSelectedOption(newValue);
    if (newValue.value !== "nouvelle") {
      TDRService.geTDR().then((result) => {
        if (result && result.data) {
          setTdrexistant(result.data?.map((row) => ({ ...row, id: row.tdr_mission_id })));
        }
      });
    }
  };

  const handleClosealert = () => {
    setOpenalert(false);
    setIscontinue(false)
  };

  const handleSectionChangeagenda = (index, field, newValue) => {
    setOptionagenda(newValue);
    if (newValue.value !== "nouvelle") {
      TDRService.getagendasimple().then((result) => {
        if (result && result.data) {
          setAgendaexistant(result.data?.map((row) => ({ ...row, id: row.id })));
        }
      });
    }
  };

  const handleTdrClick = (id,event) => {
    event.stopPropagation();
    PlanningMissionService.tdr(id).then((result) => {
      if(result && result.data){
            navigate('/mission/tdr/add/'+result.data+"/"+id);
      }else{
           
      }
    });
  };

  const handleAgendaClick = (id,planningdestination,event) => {
    event.stopPropagation();
    PlanningMissionService.agenda(id,planningdestination).then((result) => {
      if(result && result.data){
            navigate('/mission/agenda/add/'+result.data+"/"+planningdestination);
      }else{
           
      }
    });
     
  };

  //Samuela: paramètrage pour le loader
  const [openLoadingSimpleBackdrop, setOpenLoadingSimpleBackdrop] = React.useState(false);
  const [statut_val, setStatut_val] = useState({ label: 'Nouveau', id: 'Nouveau' });
  const [, setIsalert] = useState(0);
  const [, setTDR] = useState([]);
  const [loadingannulation, setLoadingannulation] = useState(false);

  useEffect(() => {
    PlanningMissionService.planningactive().then((result) => {
      setIsalert(parseInt(result.data, 10));
    });
    TDRService.getlistTDR().then((result) => {
      if (result && result.data) {
        setTDR(result.data?.map((row) => ({ ...row, id: row.tdr_mission_id })))
      }
    });

    setOpenLoadingSimpleBackdrop(true);
    PlanningMissionService.getPlanning(statutVal, statutMissionVal, dateDebut, dateFin).then((result) => {
      if (result && result.data) {
        setRows(result.data?.map((row) => ({ ...row, id: row.mission_planning_id })));
        setOpenLoadingSimpleBackdrop(false);
      } else {
        setOpenLoadingSimpleBackdrop(false);
      }
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handletdr = (filenamepdf, event) => {
    // Empêcher la propagation de l'événement
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }

    const destination = process.env.REACT_APP_API_URL_FILE;
    const fileUrl = `${destination.replace(/\/$/, '')}/${filenamepdf}`;

    try {
      // Ouvrir le PDF dans un nouvel onglet
      const newWindow = window.open(fileUrl, '_blank');

      // Vérifier si l'ouverture a réussi (peut être bloquée par les pop-up blockers)
      if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
        alert('Le navigateur a bloqué l\'ouverture du fichier. Veuillez autoriser les pop-ups pour ce site.');
      }
    } catch (error) {
      alert('Impossible d\'ouvrir le fichier');
    }
  };

  function closeDialog() {
    setConfirmationDialog({ ...confirmationDialog, openDialog: false });
  }

  function handleCloseMessage() {
    setMessage({ ...message, open: false });
  }
  const handleDelete = (id, event) => {
    event.stopPropagation();
    setId_to_delete(id);
    setConfirmationDialog({ ...confirmationDialog, openDialog: true });
  };

  const handleChangeraison = (event) => {
    setRaison(event.target.value);
  };

  const handleconfirmagenda = (event) => {
    if (optionagenda.value === "nouvelle") {
      PlanningMissionService.agenda(selectid).then((result) => {
        if (result && result.data) {
          navigate('/mission/agenda/add/' + result.data);
        }
      });
    } else {
      PlanningMissionService.agendaexistant(selectid, agendaid).then((result) => {
        if (result && result.data) {
          //navigate('/mission/agenda/add/'+result.data);
          setAgendachois(false);
        }
      });
    }
  }

  const handleconfirmtdr = (event) => {
    if (selectedOption.value === "nouvelle") {
      PlanningMissionService.tdr(selectid).then((result) => {
        if (result && result.data) {
          navigate('/mission/tdr/add/' + result.data);
        }
      });
    } else {
      PlanningMissionService.tdrexistant(selectid, tdrid).then((result) => {
        if (result && result.data) {
          setTdrchois(false)
        }
      });
    }
  }

  const handleconfirm=(event)=>
  {
     setLoadingannulation(true);
     TDRService.addraison(id_to_delete,raison).then((result) => {
      if (result) {
        setMessage({...message, open: true, color: 'green', messageInfo:"Succès"});
        setAnnule(false);
         setLoadingannulation(false);
         window.location.reload();
      } else {
        setMessage({...message, open: true, color: 'red', messageInfo: result.message});
        setAnnule(false);
        setLoadingannulation(false);
        //window.location.reload();
      }
    });
  }

  function confirmDialog() {
    setConfirmationDialog({ ...confirmationDialog, openDialog: false });
    PlanningMissionService.deleteMissionPlanning(id_to_delete).then((result) => {
      if (result.status) {
        setMessage({ ...message, open: true, color: 'green', messageInfo: result.message });
        PlanningMissionService.getPlanning(statut_val.label).then((result) => {
          if (result && result.data) {
            setRows(result.data?.map((row) => ({ ...row, id: row.mission_planning_id })));
            setOpenLoadingSimpleBackdrop(false);
          } else {
            setOpenLoadingSimpleBackdrop(false);
          }
        });
        navigate("/mission/planning_mission");
      } else {
        setMessage({ ...message, open: true, color: 'red', messageInfo: result.message });
      }
    }).catch((err) => {
      setMessage({ ...message, open: true, color: 'red', messageInfo: 'erreur' });
    });
  }

  function cancelDialog() {
    setConfirmationDialog({ ...confirmationDialog, openDialog: false });
  }

  const handleannule = (id, event) => {
    event.stopPropagation();
    setId_to_delete(id);
    setAnnule(true);
  };

  const handleenvoieplanning = (id, stateplanning, event) => {
    event.stopPropagation();
    setIdvalidate(id);
    if (stateplanning === "Nouveau") {
      setOpenalert(true);
    } else {
      navigate('/mission/planning_mission/validate/add/' + id);
    }
  }

  const seeobservation = (id) => (event) => {
    setIdplanif(id);
    event.stopPropagation();
    setOpenobservation(true);
    PlanningMissionService.getObservation(id).then((result) => {
      if (result && result.data) {
        setNote(result.data);
      } else {
        setNote([]);
      }
    });
  }

  const handleCloseobservations = () => {
    setOpenobservation(false);
  };

  const handleValidealert = () => {
    setIscontinue(true);
  };

  const handleValideconfirm = () => {
    PlanningMissionService.insertraison(raisonplanning, idvalidate).then((result) => {
      if (result) {
        navigate('/mission/planning_mission/validate/add/' + idvalidate);
      }
    });
  };

  const handlemofid = () => {
    MissionService.updateplanification(idplanif).then((result) => {
      if (result) {
        setMessage({ ...message, open: true, color: 'green', messageInfo: "Succès" });
        setOpenobservation(false);
        window.location.reload();
      } else {
        setMessage({ ...message, open: true, color: 'red', messageInfo: 'erreur' });
      }
    });
  }

  const handleCloseobservation = () => {
    setOpenobservation(false);
  };

  const handleRowClick = (params) => {
    const rowId = params.id;
    PlanningMissionService.getdetails(rowId).then((result) => {
      if (result.status) {
        setDetails(result.data);
        setOpens(true);
      } else {
        setMessage({ ...message, open: true, color: 'red', messageInfo: result.message });
      }
    })
      .catch((err) => {
        setMessage({ ...message, open: true, color: 'red', messageInfo: 'erreur' });
      });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const displayedRows = rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  return (
    <React.Fragment>
      <ConfirmationDialog openDialog={openDialog} messageDialog={messageDialog} closeDialog={closeDialog} confirmDialog={confirmDialog} cancelDialog={cancelDialog} />
      <Message open={open} color={color} messageInfo={messageInfo} handleClose={handleCloseMessage} />
      <LoadingSimpleBackdrop openLoadingSimpleBackdrop={openLoadingSimpleBackdrop} />
      <Grid container spacing={2} alignItems="center">
        {/* Statut */}
        <Grid item xs={3}>
          <Autocomplete
            options={statut}
            getOptionLabel={(option) => option.label}
            value={statutVal}
            onChange={(e, newValue) => {
              setStatutVal(newValue);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Statut"
                size="small"
                fullWidth
                variant="outlined"
              />
            )}
          />
        </Grid>

        {/* Statut validation */}
        <Grid item xs={3}>
          <Autocomplete
            options={statutmission}
            getOptionLabel={(option) => option.label}
            value={statutMissionVal}
            onChange={(e, newValue) => setStatutMissionVal(newValue)}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Statut validation"
                size="small"
                fullWidth
                variant="outlined"
              />
            )}
          />
        </Grid>

        {/* Date début */}
        <Grid item xs={2}>
          <TextField
            label="Date début"
            type="date"
            size="small"
            variant="outlined"
            fullWidth
            value={dateDebut}
            onChange={(e) => setDateDebut(e.target.value)}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>

        {/* Date fin */}
        <Grid item xs={2}>
          <TextField
            label="Date fin"
            type="date"
            size="small"
            variant="outlined"
            fullWidth
            value={dateFin}
            onChange={(e) => setDateFin(e.target.value)}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>

        {/* Bouton filtrer */}
        <Grid item xs={2}>
          <LoadingButton
            loading={loading}
            variant="contained"
            color="primary"
            fullWidth
            onClick={handleFiltrer}
          >
            Filtrer
          </LoadingButton>
        </Grid>

      </Grid>

      <br /><br />
      {/* <Title>Planifications</Title> */}
      <Spacer y={2} />
      <div style={{ height: 400, width: '100%' }}>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="mission table">
            <TableHead>
              <TableRow>
                <TableCell>N°</TableCell>
                <TableCell>Réference</TableCell>
                <TableCell>Categorie Mission</TableCell>
                <TableCell>Objet de la mission</TableCell>
                <TableCell>Statut des missionaires</TableCell>
                <TableCell>
                  Statut
                </TableCell>
                <TableCell>TDR/Agenda</TableCell>
                {statut_val.label !== "Nouveau" &&
                  <TableCell>Validateur</TableCell>
                }
                <TableCell>Créer par</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {displayedRows.length > 0 ? (
                displayedRows.map((row) => (
                  <TableRow key={row.id} onClick={() => handleRowClick(row)}>
                    <TableCell>{row.numero}</TableCell>
                    <TableCell>{row.reference}</TableCell>
                    <TableCell>{row.categorie}</TableCell>
                    <TableCell>{row.mission_title}</TableCell>
                    <TableCell>
                      <ul>
                        {row.users.map((ts, index) => (
                          <li key={index}>
                            {ts.nom} {ts.validate}
                          </li>
                        ))}
                      </ul>
                    </TableCell>
                    <TableCell>
                      {row.state === "Nouveau" && row.stateplanning === "Nouveau" && (
                        <>
                          Nouveau mission
                        </>
                      )}
                      {row.state === "Nouveau" && row.stateplanning === "Planifié" && (
                        <>
                          Mission plannifié
                        </>
                      )}
                      {row.state === "Nouveau" && row.stateplanning === "En attente de validation" && (
                        <>
                          Planning en attente de validation
                        </>
                      )}
                      {row.stateplanning === "Refusé" && (
                        <>
                          Planning  refusé
                        </>
                      )}
                      {row.state === "Refusé" && (
                        <>
                          Mission Refusé
                        </>
                      )}
                      {row.state === "En attente de validation" && (
                        <>
                          Mission en atttente de validation
                        </>
                      )}
                      {row.state === "Validé" && (
                        <>
                          Mission validé
                        </>
                      )}
                    </TableCell>
                      
                    {statut_val.label !== "Nouveau" &&
                      <TableCell>
                        {statut_val.label !== "Nouveau" && row.validateurlist?.length > 0 ? (
                          <Stack direction="column" spacing={0.5}>
                            {row.validateurlist.map((ts, index) => (
                              <Stack
                                key={index}
                                direction="row"
                                spacing={1}
                                alignItems="center"
                              >
                                {ts.state === "Validé" && (
                                  <>
                                    <CheckCircleIcon color="success" fontSize="small" />
                                    <span>Validé par {ts.nom}</span>
                                  </>
                                )}

                                {ts.state === "En attente de validation" && (
                                  <>
                                    <PendingActionsIcon color="warning" fontSize="small" />
                                    <span>En attente de validation par {ts.nom}</span>
                                  </>
                                )}

                                {ts.state === "Refusé" && (
                                  <>
                                    <BlockIcon color="error" fontSize="small" />
                                    <span>Refusé par {ts.nom}</span>
                                  </>
                                )}
                              </Stack>
                            ))}
                          </Stack>
                        ) : (
                          "—"
                        )}
                      </TableCell>}
                    <TableCell>
                        <strong>
                              <Button title="TDR"  disabled={statut_val.label !== "Nouveau"}  onClick={(event) => handleTdrClick(row.id, event)}>
                                     {row.tdr==="true"? <Subject style={{ color: "green" }} /> : <PostAdd style={{ color: "red" }} />}
                              </Button>
                               <Button title="Agenda"  disabled={statut_val.label !== "Nouveau"} onClick={(event) => handleAgendaClick(row.id,row.planningdestination,event)}>
                                     {row.agenda==="true"? <CalendarToday style={{ color: "green" }} /> : <CalendarTodayTwoTone style={{ color: "red" }} />}
                                </Button>
                         </strong>
                    </TableCell>
                    <TableCell>{row.nom_editeur}</TableCell>
                    <TableCell>
                      <strong>
                        {row.state === "Refusé" ? (
                          <Button
                            title="Voir les observations"
                            onClick={(e) => {
                              e.stopPropagation();
                              seeobservation(row.file_request_id)(e);
                            }}
                          >
                            <RemoveRedEyeIcon style={{ width: 40, height: 40 }} />
                          </Button>
                        ) : (
                          <>
                            {/* Bouton Envoyer pour validation */}
                            {(
                              (statut_val.label === "Nouveau") ||
                              (statut_val.label === "Planning" && row.active === false) ||
                              (statut_val.label === "Réel" && row.state === "Nouveau") ||
                              (statut_val.label === "Tous" &&
                                row.state === "Nouveau" &&
                                (row.stateplanning === "Planifié" || row.stateplanning === "En attente de validation" || row.stateplanning === "Nouveau"))
                            ) && (
                                <Button
                                  title="Envoyer pour validation"
                                  onClick={(event) => handleenvoieplanning(row.id, row.stateplanning, event)}
                                >
                                  <CheckIcon style={{ color: "green" }} />
                                </Button>
                              )}

                            {/* Boutons communs à plusieurs états */}
                            {(statut_val.label === "Nouveau" && row.stateplanning === "Nouveau") && (
                              <Button
                                title="Modifier le planning"
                                onClick={() => navigate(`/mission/planning_mission/add/${row.id}`)}
                              >
                                <CreateTwoTone style={{ color: "black" }} />
                              </Button>
                            )}

                            {/* Bouton Supprimer */}
                            {(statut_val.label === "Nouveau" ||
                              (statut_val.label === "Tous" && row.state === "Nouveau" && row.stateplanning === "Nouveau")) && (
                                <Button title="Supprimer le planning" onClick={(event) => handleDelete(row.id, event)}>
                                  <DeleteOutlineRounded style={{ color: 'red' }} />
                                </Button>
                              )}

                            {/* Bouton Télécharger TDR */}
                            {((statut_val.label === "Tous" && row.state !== "Nouveau") ||
                              (statut_val.label === "Réel" && row.lienpdf && row.lienpdf !== "")) && (
                                <Button title="Télécharger TDR" onClick={(event) => handletdr(row.lienpdf, event)}>
                                  <DownloadOutlined style={{ color: "#1a5fa1" }} />
                                </Button>
                              )}

                            {/* Bouton Annuler validation */}
                            {((row.state === "En attente de validation" || row.state === "Validé") && row.lienpdf && row.lienpdf !== "") && (
                              <Button title="Annuler la validation de la mission" onClick={(event) => handleannule(row.id, event)}>
                                <ClearIcon style={{ color: "red" }} />
                              </Button>
                            )}
                            {/* Bouton reenvoie plannning mission*/}
                            {row.stateplanning === "Refusé" && (
                              <Button
                                title="Réenvoi du planning de mission"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  navigate('/mission/planning_mission/planning/add/' + row.id)
                                }}
                              >
                                <SettingsBackupRestoreIcon
                                  style={{ color: "green", width: 40, height: 40 }}
                                />
                              </Button>
                            )}
                          </>
                        )}
                      </strong>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={6} align="center">Aucune donnée à afficher</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </div>
      <Dialog
        open={opens}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="md"
      >
        <DialogTitle id="form-dialog-title" style={{ backgroundColor: "#133E67" }}>
          {"Détails de la mission réf: "}
          {details && details.length > 0 && details[0].reference}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {details && details.length > 0 ? (
              <Grid container spacing={3}>
                <Grid item xs={3}>
                  <Typography variant="body1" align="right">Objet de la mission :</Typography>
                </Grid>
                <Grid item xs={9}>
                  <Typography variant="body1">{details[0].mission_title}</Typography>
                </Grid>

                <Grid item xs={3}>
                  <Typography variant="body1" align="right">Catégorie :</Typography>
                </Grid>
                <Grid item xs={9}>
                  {details[0].categorie && details[0].categorie.length > 0 ? (
                    details[0].categorie.map((ts, index) => (
                      <Typography key={index} variant="body1">
                        {ts.name}{index !== details[0].categorie.length - 1 && ', '}
                      </Typography>
                    ))
                  ) : (
                    <Typography variant="body1">Aucune catégorie</Typography>
                  )}
                </Grid>

                {details[0].lieu !== "" && (
                  <>
                    <Grid item xs={3}>
                      <Typography variant="body1" align="right">Date :</Typography>
                    </Grid>
                    <Grid item xs={9}>
                      <Typography variant="body1">
                        {details[0].date_depart} au {details[0].date_retour}
                      </Typography>
                    </Grid>

                    <Grid item xs={3}>
                      <Typography variant="body1" align="right">Direction de destination :</Typography>
                    </Grid>
                    <Grid item xs={9}>
                      <Typography variant="body1">{details[0].direction}</Typography>
                    </Grid>

                    <Grid item xs={3}>
                      <Typography variant="body1" align="right">Lieu :</Typography>
                    </Grid>
                    <Grid item xs={9}>
                      <Typography variant="body1">{details[0].lieu}</Typography>
                    </Grid>

                    <Grid item xs={3}>
                      <Typography variant="body1" align="right">Missionnaires :</Typography>
                    </Grid>
                    <Grid item xs={9}>
                      {details[0].missionnary && details[0].missionnary.length > 0 ? (
                        details[0].missionnary.map((ts, index) => (
                          <Typography key={index} variant="body1">
                            {ts.nom}{index !== details[0].missionnary.length - 1 && ', '}
                          </Typography>
                        ))
                      ) : (
                        <Typography variant="body1">Aucun missionnaire</Typography>
                      )}
                    </Grid>
                  </>
                )}
                {details &&
                  details[0] &&
                  details[0].lieu === "" &&
                  details[0].destination &&
                  details[0].destination.length > 0 && (
                    <>
                      <Grid item xs={12}>
                        <TableContainer component={Paper}>
                          <Table sx={{ minWidth: 650 }} aria-label="simple table">
                            <TableHead>
                              <TableRow>
                                <TableCell align="center">Lieu/Direction</TableCell>
                                <TableCell align="center">Date</TableCell>
                                <TableCell align="center">Missionaires</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {details[0].destination.map((row) => (
                                <TableRow
                                  key={row.planning_destination}
                                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                  <TableCell component="th" scope="row">
                                    {row.lieu}/{row.direction}
                                  </TableCell>
                                  <TableCell align="center">{row.date_debut} au {row.date_fin}</TableCell>
                                  <TableCell align="center">
                                    {row.missionary.map((ts, index) => (
                                      <p key={index}>{ts.nom}</p>
                                    ))}
                                  </TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Grid>
                    </>
                  )}
                <Grid item xs={3}>
                  <Typography variant="body1" align="right">Transport :</Typography>
                </Grid>
                <Grid item xs={9}>
                  {details[0].transport && details[0].transport.length > 0 ? (
                    details[0].transport.map((ts, index) => (
                      <Typography key={index} variant="body1">
                        {ts.designation}{index !== details[0].transport.length - 1 && ', '}
                      </Typography>
                    ))
                  ) : (
                    <Typography variant="body1">Aucun transport</Typography>
                  )}
                </Grid>

                <Grid item xs={3}>
                  <Typography variant="body1" align="right">Autre participant :</Typography>
                </Grid>
                <Grid item xs={9}>
                  {details[0].partnership && typeof details[0].partnership === 'string' && details[0].partnership.length > 0 ? (
                    JSON.parse(details[0].partnership).map((ts, index) => (
                      <Typography key={index} variant="body1">
                        {ts}{index !== JSON.parse(details[0].partnership).length - 1 && ', '}
                      </Typography>
                    ))
                  ) : (
                    <Typography variant="body1">Aucun partenaire</Typography>
                  )}
                </Grid>

                {details[0].tdrref && (
                  <>
                    <Grid item xs={3}>
                      <Typography variant="body1" align="right">TDR :</Typography>
                    </Grid>
                    <Grid item xs={9}>
                      <Typography variant="body1">
                        {details[0].tdrref.title}-{details[0].tdrref.reference}
                      </Typography>
                    </Grid>
                  </>
                )}

                {details[0].agedref && details[0].agedref.length > 0 && (
                  <>
                    <Grid item xs={3}>
                      <Typography variant="body1" align="right">Agenda :</Typography>
                    </Grid>
                    <Grid item xs={9}>
                      {details[0].agedref.map((agenda, index) => (
                        <Typography key={index} variant="body1">
                          {agenda.title}-{agenda.reference}
                        </Typography>
                      ))}
                    </Grid>
                  </>
                )}
              </Grid>
            ) : (
              <Typography variant="body1">Aucune donnée disponible</Typography>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={handleClose} autoFocus>
            Fermer
          </Button>
        </DialogActions>
      </Dialog>
      <div>
        <Dialog fullWidth maxWidth="md" open={openobservation} onClose={handleCloseobservation}>
          <DialogTitle id="form-dialog-title" color="primary"  >Observation refus du mission</DialogTitle>
          <DialogContent>
            <DialogContentText>
              <Grid container justifyContent="center" spacing={2}>

                <Grid container item spacing={2} xs={8} >
                  <Grid item xs={5}>
                    <label >Context :</label>
                  </Grid>
                  <Grid item xs={7}>
                    <label >{note.Context}</label>
                  </Grid>
                  <Grid item xs={5}>
                    <label >Objectifs :</label>
                  </Grid>
                  <Grid item xs={7}>
                    <label >{note.Objectifs}</label>
                  </Grid>
                  <Grid item xs={5}>
                    <label >Resulat attendus</label>
                  </Grid>
                  <Grid item xs={7}>
                    <label >{note["Resulat attendus"]}</label>
                  </Grid>
                  <Grid item xs={5}>
                    <label >Tâche :</label>
                  </Grid>
                  <Grid item xs={7}>
                    <label >{note.Tâche}</label>
                  </Grid>
                  <Grid item xs={5}>
                    <label >Agenda :</label>
                  </Grid>
                  <Grid item xs={7}>
                    <label >{note.Agenda}</label>
                  </Grid>
                </Grid>
              </Grid>

            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button style={{ backgroundColor: 'rgb(19, 62, 103)', color: "#FFFFFF" }} variant="contained" color="primary" onClick={handlemofid} >MODIFIER planning</Button>
            <Button variant="contained" color="secondary" onClick={handleCloseobservations} >FERMER</Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={annule}
          onClose={() => setAnnule(false)}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle>Annulation de la demande de validation de la mission</DialogTitle>
          <DialogContent dividers>
            <TextField
              fullWidth
              label="Raison"
              variant="outlined"
              name="raison"
              multiline
              minRows={3}
              maxRows={5}
              value={raison}
              onChange={handleChangeraison}
              autoFocus
              margin="dense"
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setAnnule(false)} color="secondary">
              Annuler
            </Button>
            <LoadingButton
              onClick={handleconfirm}
              color="primary"
              loading={loadingannulation}
              variant="contained"
            >
              Confirmer
            </LoadingButton>

          </DialogActions>
        </Dialog>
      </div>
      {/* Dialogue d'erreur : statut obligatoire pour filtrer */}
      <div>
        <Dialog
          open={statutErrorDialog}
          onClose={() => setStatutErrorDialog(false)}
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle style={{ color: '#d32f2f' }}>Statut manquant</DialogTitle>
          <DialogContent dividers>
            <DialogContentText>
              Veuillez choisir un statut avant de lancer le filtrage.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              color="primary"
              onClick={() => setStatutErrorDialog(false)}
              autoFocus
            >
              OK
            </Button>
          </DialogActions>
        </Dialog>
      </div>
      {/* Dialogue pour le choix agenda ou tdr  */}
      <div>
        <Dialog
          open={tdrchois}
          onClose={() => setTdrchois(false)}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle>Choisir une TDR</DialogTitle>
          <DialogContent dividers>
            <Autocomplete
              fullWidth
              id="tdr-autocomplete"
              options={options}
              getOptionLabel={(option) => option.label}
              value={selectedOption}
              onChange={(event, newValue) => handleSectionChange(0, "tdr", newValue)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  label="Sélectionner un TDR"
                  placeholder="Choisissez..."
                  size="small"
                  variant="outlined"
                  InputProps={{ ...params.InputProps, type: "search" }}
                />
              )}
              isOptionEqualToValue={(option, value) => option.value === value.value}
            />
            <br />
            {selectedOption.value === "existant" &&
              <Autocomplete
                onChange={handleChangetdr}
                options={tdrexistant}
                getOptionLabel={(option) => option.title + ' (' + option.reference + '- ' + option.state + ')'}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    label="TDR"
                    size="small"
                    variant="outlined"
                    InputProps={{ ...params.InputProps, type: "search" }}
                  />
                )}
              />
            }

          </DialogContent>
          <DialogActions>
            <Button onClick={() => setTdrchois(false)} color="secondary">
              Annuler
            </Button>
            <Button onClick={handleconfirmtdr} color="primary">
              Confirmer
            </Button>

          </DialogActions>
        </Dialog>
        <Dialog
          open={agendachois}
          onClose={() => setAgendachois(false)}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle>Choisir une Agenda</DialogTitle>
          <DialogContent dividers>
            <Autocomplete
              fullWidth
              id="tdr-autocomplete"
              options={agendaoptions}
              getOptionLabel={(option) => option.label}
              value={optionagenda}
              onChange={(event, newValue) => handleSectionChangeagenda(0, "agenda", newValue)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  label="Sélectionner un Agenda"
                  placeholder="Choisissez..."
                  size="small"
                  variant="outlined"
                  InputProps={{ ...params.InputProps, type: "search" }}
                />
              )}
              isOptionEqualToValue={(option, value) => option.value === value.value}
            />
            <br />
            {optionagenda.value === "existant" &&
              <Autocomplete
                onChange={handleChangeagenda}
                options={agendaexistant.filter((option) => option.mission_planning_id === null)}
                getOptionLabel={(option) => option.title + ' (' + option.reference + ')'}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    label="Agenda"
                    size="small"
                    variant="outlined"
                    InputProps={{ ...params.InputProps, type: 'search' }}
                  />
                )}
              />
            }

          </DialogContent>
          <DialogActions>
            <Button onClick={() => setAgendachois(false)} color="secondary">
              Annuler
            </Button>
            <Button onClick={handleconfirmagenda} color="primary">
              Confirmer
            </Button>
          </DialogActions>
        </Dialog>
      </div>
      <div>
        <Dialog
          open={openalert}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleClosealert}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle>Envoi pour validation d'une mission non planifiée</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              <p>L'envoi d'une mission non planifiée pour validation nécessite une justification obligatoire.</p>
              <p>Un e-mail sera automatiquement envoyé à votre supérieur hiérarchique ainsi qu'au <b> DG et  DP</b>.</p>
              <>
                {!iscontinue && <Alert severity="info">
                  <AlertTitle>Info</AlertTitle>
                  Souhaitez-vous continuer ?
                </Alert>}
                {iscontinue &&
                  <>
                    <TextField
                      id="raisonplanning"
                      label="Raison"
                      variant="outlined"
                      fullWidth
                      value={raisonplanning}
                      onChange={(e) => setRaisonplanning(e.target.value)}
                      error={!raisonplanning.trim()}
                      helperText={!raisonplanning.trim() ? "La raison ne peut pas être vide !" : ""}
                      required
                      sx={{
                        mt: 2,
                        '& .MuiOutlinedInput-root': {
                          '&.Mui-error fieldset': {
                            borderColor: 'red',
                          },
                        }
                      }}
                    />
                    {!raisonplanning.trim() && (
                      <Alert severity="error" sx={{ mt: 1 }}>
                        La justification est obligatoire pour une mission non planifiée.
                      </Alert>
                    )}
                  </>
                }
              </>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            {!iscontinue && <Button variant="outlined" color="primary" onClick={handleValidealert}>Continuer</Button>}
            {iscontinue && <Button variant="outlined" color="primary" disabled={!raisonplanning.trim()} onClick={handleValideconfirm}>Confirmer</Button>}
            <Button variant="outlined" color="secondary" onClick={handleClosealert}>ANNULER</Button>
          </DialogActions>
        </Dialog>
      </div>
    </React.Fragment>
  );
}
